import WidgetDateContainer from './WidgetDateContainer';

export default WidgetDateContainer;
